import React from "react";
import { Cherry, Gem } from "lucide-react";
import { TbNumber7 } from "react-icons/tb";

/**
 * 3-SlotBET Game Configuration
 */
export const THREE_SLOT_CONFIG = {
  name: "3-SLOTBET",
  reels: 3,
  rows: 3,
  paylines: 1,
  paylineDescription: "Match all 3 symbols on the center line",
  initialReels: ["cherry", "bar", "seven"],
};

export const THEME_OPTIONS = [
  {
    id: "classic_crypto",
    label: "Classic Vegas & Crypto",
    description: "Traditional 3-reel pokies symbols: Cherry, BAR, Diamond, and Lucky Seven with progressive tier pools.",
  },
];

export const SYMBOLS = [
  {
    id: "cherry",
    symbol: (
      <Cherry
        size="1em"
        strokeWidth={2}
        style={{ transform: "translateY(-25%)" }}
      />
    ),
    iconText: "🍒",
    label: "Cherry",
    multiplier: "5x",
    tier: "Small Win",
    tierColor: "#ef4444",
    payout: "Small Win",
  },
  {
    id: "bar",
    symbol: "BAR",
    iconText: "BAR",
    label: "BAR",
    multiplier: "15x",
    tier: "Medium Win",
    tierColor: "#3b82f6",
    payout: "Medium Win",
  },
  {
    id: "diamond",
    symbol: <Gem size="1em" strokeWidth={2} />,
    iconText: "💎",
    label: "Diamond",
    multiplier: "50x",
    tier: "Major Win",
    tierColor: "#8b5cf6",
    payout: "Major Win",
  },
  {
    id: "seven",
    symbol: <TbNumber7 size="1.2em" strokeWidth={2} />,
    iconText: "7️⃣",
    label: "Seven",
    multiplier: "JACKPOT",
    tier: "Jackpot",
    tierColor: "#f59e0b",
    payout: "JACKPOT",
  },
];

export const getSymbolsByTheme = (themeName = "classic_crypto") => {
  return SYMBOLS;
};

export const getRandomSymbol = () => {
  return SYMBOLS[
    Math.floor(Math.random() * SYMBOLS.length)
  ];
};

export const getSymbolById = (id) => {
  return SYMBOLS.find(
    (symbol) => symbol.id === id
  );
};